import { WrenchIcon } from "@phosphor-icons/react";
import { type NavigateOptions } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import PageError from "./PageError";

interface Props {
  backOptions?: NavigateOptions;
}

export const GeneralPageError = ({ backOptions = { to: "/" } }: Props) => {
  const intl = useIntl();

  return (
    <PageError
      subtitles={[
        intl.formatMessage({
          id: "pageDidntWork",
          defaultMessage:
            "This page didn't work as we expected. We will fix it and return everything as it should be pretty soon.",
        }),
      ]}
      icon={<WrenchIcon size={60} color="#0212294d" />}
      back={{
        text: intl.formatMessage({
          id: "backToHome",
          defaultMessage: "Back to home",
        }),
        options: backOptions,
      }}
    />
  );
};
